import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import SelectDropDown from "../selectdropdown/SelectDropDown";


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class HolidayModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    dropDownGetValues(fieldname) {
        let getArray = [];
        const newObj1 = {
            value: "0",
            label: "Select"
        }
        getArray.push(newObj1);

        [...(this.props.globals || [])]
            .sort((a, b) =>
                String(a.branch_name ?? "").localeCompare(String(b.branch_name ?? ""), undefined, { sensitivity: "base", numeric: true })
            )
            .forEach((stumap) => {
                getArray.push({
                    value: stumap.id,
                    label: stumap.branch_name
                });
            });
        return getArray;
    }

    render() {
        console.log("gg", this.props.globals);

        return (
            <Modal
                {...this.props}
                size="md"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header
                    closeButton
                    style={{
                        background:
                            "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))",
                        color: "#fff",
                        borderBottom: "none"
                    }}
                >
                    <Modal.Title
                        className="text-center"
                        style={{
                            width: "100%",
                            fontWeight: "700"
                        }}
                    >
                        Mark Holiday
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row>
                        <Col lg={12} md={12} sm={12}>
                            <h6 style={{ display: "inline" }}>Branch</h6>
                            <p style={{ display: "inline" }}><span className="text-danger">   {this.props.stateData.holidayBranchError}</span></p>
                            <SelectDropDown
                                stateData={this.props.stateData.holidayBranchVal}
                                handleChange={this.props.selecthandleInputChange}
                                name="holidayBranch"
                                options={this.dropDownGetValues("holidayBranch")}
                                placeholderName={'Branch'}
                                dropdownIndicator={{ DropdownIndicator }}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} class="text-center">
                            <h6 className="text-center mb-4 mt-3">Are you sure you want to mark as Holiday</h6>
                            <div className="d-flex flex-row justify-content-center">
                                <Button className="btn btn-success text-uppercase px-lg-5 ml-1" onClick={this.props.markHoliday} >Yes</Button>
                                <Button className="btn btn-danger text-uppercase px-lg-5 ml-1" onClick={this.props.onHide}>No</Button>
                            </div>
                            <p className="text-center text-danger mt-2">{this.props.stateData.submitError}</p>
                            <p className="text-center text-danger mt-2">{this.props.stateData.currentStep == 5 ? "Marked as Holiday" : ""}</p>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            // <Modal
            //     {...this.props}
            //     size="md"
            //     centered
            // >
            //     <Modal.Body
            //         style={{
            //             padding: "0",
            //             borderRadius: "22px",
            //             overflow: "hidden",
            //             background: "#f8fafc"
            //         }}
            //     >

            //         {/* Header */}
            //         <div
            //             style={{
            //                 background: "linear-gradient(135deg, #f59e0b, #f97316)",
            //                 padding: "28px 24px",
            //                 textAlign: "center",
            //                 color: "#fff",
            //                 position: "relative"
            //             }}
            //         >

            //             <button
            //                 onClick={this.props.onHide}
            //                 style={{
            //                     position: "absolute",
            //                     top: "14px",
            //                     right: "14px",
            //                     border: "none",
            //                     background: "rgba(255,255,255,0.18)",
            //                     color: "#fff",
            //                     width: "34px",
            //                     height: "34px",
            //                     borderRadius: "50%",
            //                     cursor: "pointer",
            //                     fontSize: "16px"
            //                 }}
            //             >
            //                 ✕
            //             </button>

            //             <div
            //                 style={{
            //                     width: "75px",
            //                     height: "75px",
            //                     borderRadius: "50%",
            //                     background: "rgba(255,255,255,0.18)",
            //                     display: "flex",
            //                     alignItems: "center",
            //                     justifyContent: "center",
            //                     margin: "0 auto 15px auto",
            //                     fontSize: "34px"
            //                 }}
            //             >
            //                 <i className="fa fa-calendar"></i>
            //             </div>

            //             <h3
            //                 style={{
            //                     marginBottom: "6px",
            //                     fontWeight: "700"
            //                 }}
            //             >
            //                 Mark Holiday
            //             </h3>

            //             <p
            //                 style={{
            //                     marginBottom: 0,
            //                     opacity: 0.9,
            //                     fontSize: "14px"
            //                 }}
            //             >
            //                 Select branch and confirm holiday declaration
            //             </p>

            //         </div>

            //         {/* Body */}
            //         <div style={{ padding: "24px" }}>

            //             {/* Branch Selection */}
            //             <div className="mb-4">

            //                 <div className="d-flex align-items-center mb-2">
            //                     <h6
            //                         style={{
            //                             marginBottom: 0,
            //                             fontWeight: "700",
            //                             color: "#374151"
            //                         }}
            //                     >
            //                         Select Branch
            //                     </h6>

            //                     <span
            //                         style={{
            //                             color: "#ef4444",
            //                             marginLeft: "8px",
            //                             fontSize: "13px",
            //                             fontWeight: "600"
            //                         }}
            //                     >
            //                         {this.props.stateData.holidayBranchError}
            //                     </span>
            //                 </div>

            //                 <SelectDropDown
            //                     stateData={this.props.stateData.holidayBranchVal}
            //                     handleChange={this.props.selecthandleInputChange}
            //                     name="holidayBranch"
            //                     options={this.dropDownGetValues("holidayBranch")}
            //                     placeholderName={"Choose Branch"}
            //                     dropdownIndicator={{ DropdownIndicator }}
            //                 />

            //             </div>

            //             {/* Confirmation Card */}
            //             <div
            //                 style={{
            //                     background: "linear-gradient(135deg, #fff7ed, #ffedd5)",
            //                     border: "1px solid #fdba74",
            //                     borderRadius: "18px",
            //                     padding: "22px",
            //                     textAlign: "center",
            //                     boxShadow: "0 6px 18px rgba(249,115,22,0.12)"
            //                 }}
            //             >

            //                 <div
            //                     style={{
            //                         width: "70px",
            //                         height: "70px",
            //                         borderRadius: "50%",
            //                         background: "#f97316",
            //                         color: "#fff",
            //                         display: "flex",
            //                         alignItems: "center",
            //                         justifyContent: "center",
            //                         fontSize: "32px",
            //                         margin: "0 auto 18px auto"
            //                     }}
            //                 >
            //                    📆
            //                 </div>

            //                 <h5
            //                     style={{
            //                         fontWeight: "700",
            //                         color: "#9a3412",
            //                         marginBottom: "8px"
            //                     }}
            //                 >
            //                     Confirm Holiday
            //                 </h5>

            //                 <p
            //                     style={{
            //                         color: "#7c2d12",
            //                         fontSize: "14px",
            //                         marginBottom: "20px",
            //                         lineHeight: "22px"
            //                     }}
            //                 >
            //                     Are you sure you want to mark attendance as holiday for the selected branch?
            //                 </p>

            //                 {/* Buttons */}
            //                 <div
            //                     className="d-flex justify-content-center flex-wrap"
            //                     style={{
            //                         gap: "12px"
            //                     }}
            //                 >

            //                     <Button
            //                         onClick={this.props.markHoliday}
            //                         style={{
            //                             background:
            //                                 "linear-gradient(135deg, #16a34a, #22c55e)",
            //                             border: "none",
            //                             borderRadius: "12px",
            //                             padding: "10px 28px",
            //                             fontWeight: "700",
            //                             fontSize: "14px",
            //                             boxShadow:
            //                                 "0 6px 16px rgba(34,197,94,0.28)"
            //                         }}
            //                     >
            //                         <i className="fa fa-check mr-2"></i>
            //                         Yes, Mark Holiday
            //                     </Button>

            //                     <Button
            //                         onClick={this.props.onHide}
            //                         style={{
            //                             background:
            //                                 "linear-gradient(135deg, #dc2626, #ef4444)",
            //                             border: "none",
            //                             borderRadius: "12px",
            //                             padding: "10px 28px",
            //                             fontWeight: "700",
            //                             fontSize: "14px",
            //                             boxShadow:
            //                                 "0 6px 16px rgba(239,68,68,0.28)"
            //                         }}
            //                     >
            //                         <i className="fa fa-times mr-2"></i>
            //                         Cancel
            //                     </Button>

            //                 </div>

            //                 {/* Messages */}
            //                 <div className="mt-3">

            //                     <p
            //                         style={{
            //                             color: "#ef4444",
            //                             fontWeight: "600",
            //                             marginBottom: "6px",
            //                             fontSize: "14px"
            //                         }}
            //                     >
            //                         {this.props.stateData.submitError}
            //                     </p>

            //                     {
            //                         this.props.stateData.currentStep == 5 ? (
            //                             <p
            //                                 style={{
            //                                     color: "#16a34a",
            //                                     fontWeight: "700",
            //                                     marginBottom: 0,
            //                                     fontSize: "14px"
            //                                 }}
            //                             >
            //                                 <i className="fa fa-check-circle mr-1"></i>
            //                                 Holiday marked successfully
            //                             </p>
            //                         ) : null
            //                     }

            //                 </div>

            //             </div>

            //         </div>

            //     </Modal.Body>
            // </Modal>
        )
    }
}

export default HolidayModal


